// Generated by scripts/sync-templates.mjs. Do not edit.
import t0 from './appearance-release.md?raw'

export interface BundledTemplateFile {
  fileName: string
  source: string
}

export const bundledTemplateFiles: BundledTemplateFile[] = [
  { fileName: "appearance-release.md", source: t0 },
]
